import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import SignInView from "../views/SignInView.vue";
import AdminLayout from "../views/layout/AdminLayout.vue";
import DashboardView from "../views/DashboardView.vue";
import AboutView from "../views/AboutView.vue";
import HeroView from "../views/HeroView.vue";
import ServiceView from "@/views/ServiceView.vue";
import ServiceClientView from "@/views/ServiceClientView.vue";
import MessageView from "@/views/MessageView.vue";
import ProjectView from "@/views/ProjectView.vue";
import CategoryView from "@/views/CategoryView.vue";
import ProjectPostView from "@/views/ProjectClientsView.vue";
import ProjectDetailView from "@/views/ProjectDetailView.vue";
import ServiceDetailView from "@/views/ServiceDetailView.vue";
import ComingSoonView from "@/views/ComingSoonView.vue";
import NotFoundView from "@/views/404View.vue";
import BlogView from "@/views/BlogView.vue";
import BlogDetailView from "@/views/BlogDetailView.vue";
import BlogClientView from "@/views/BlogClientView.vue";
import SettingView from "@/views/SettingView.vue";
import LoginLogsView from "@/views/LoginLogsView.vue";
import { useAuthStore } from "@/stores/auth";
import { securityManager } from "@/composables/useSecurityManager";

const requireAuth = (to, from, next) => {
  const authStore = useAuthStore();
  // console.log("isAuthenticated:", authStore.isAuthenticated);
  if (!authStore.isAuthenticated) {
    next("/borenn");
    return;
  }
  next();
};

const redirectIfAuthenticated = (to, from, next) => {
  const authStore = useAuthStore();
  if (authStore.isAuthenticated) {
    next("/admin/hero");
  } else {
    next();
  }
};

// Security guard for public routes
const securityGuard = (to, from, next) => {
  const authStore = useAuthStore();
  if (!authStore.isAuthenticated) {
    // Apply security measures for non-authenticated users
    setTimeout(() => {
      securityManager.init();
    }, 100);
  }
  next();
};

const routes = [
  // Public
  {
    path: "/",
    name: "home",
    component: HomeView,
    beforeEnter: securityGuard,
  },
  {
    path: "/about",
    name: "about",
    component: AboutView,
    beforeEnter: securityGuard,
  },
  {
    path: "/services-clients",
    name: "services-clients",
    component: ServiceClientView,
    beforeEnter: securityGuard,
  },
  {
    path: "/project-posts",
    name: "ProjectPosts",
    component: ProjectPostView,
    beforeEnter: securityGuard,
  },
  {
    path: "/blogs-posts",
    name: "BlogPosts",
    component: BlogClientView,
    beforeEnter: securityGuard,
  },
  {
    path: "/not-found",
    name: "NotFound",
    component: NotFoundView,
    beforeEnter: securityGuard,
  },
  {
    path: "/coming-soon",
    name: "ComingSoon",
    component: ComingSoonView,
    beforeEnter: securityGuard,
  },
  {
    path: "/borenn",
    name: "signin",
    component: SignInView,
    beforeEnter: redirectIfAuthenticated,
  },
  {
    path: "/project-posts/:id",
    name: "project-detail",
    component: ProjectDetailView,
    beforeEnter: securityGuard,
  },
  {
    path: "/blog-posts/:id",
    name: "blog-post-detail",
    component: BlogDetailView,
    beforeEnter: securityGuard,
  },
  {
    path: "/services/:id",
    name: "services-details",
    component: ServiceDetailView,
    beforeEnter: securityGuard,
  },
  // Admin
  {
    path: "/admin",
    name: "admin",
    component: AdminLayout,
    redirect: "/admin/hero",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: DashboardView,
        beforeEnter: requireAuth,
      },

      {
        path: "hero",
        name: "Hero",
        component: HeroView,
        beforeEnter: requireAuth,
      },
      {
        path: "services",
        name: "Services",
        component: ServiceView,
        beforeEnter: requireAuth,
      },
      {
        path: "messages",
        name: "Messages",
        component: MessageView,
        beforeEnter: requireAuth,
      },
      {
        path: "projects",
        name: "Projects",
        component: ProjectView,
        beforeEnter: requireAuth,
      },
      {
        path: "categories",
        name: "Categories",
        component: CategoryView,
        beforeEnter: requireAuth,
      },
      {
        path: "blogs",
        name: "blogs",
        component: BlogView,
        beforeEnter: requireAuth,
      },
      {
        path: "settings",
        name: "settings",
        component: SettingView,
        beforeEnter: requireAuth,
      },
      {
        path: "login-logs",
        name: "login-logs",
        component: LoginLogsView,
        beforeEnter: requireAuth,
      },
    ],
  },
  // Catch-all for undefined routes
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      // Handle section navigation with smooth scrolling
      return {
        el: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      // Restore saved scroll position (e.g., on browser back/forward)
      return savedPosition;
    } else {
      // Default: scroll to top
      return { top: 0 };
    }
  },
});

export default router;
